import './ExpiredPage.scss';

export function ExpiredPage() {
  return (
    <main className="expired-page">
      <div className="expired-page__container">
        <div className="expired-page__content">
          <span className="expired-page__icon">410</span>
          <h1 className="expired-page__title">Request Expired</h1>
          <p className="expired-page__message">
            This shared request has expired and is no longer available.
            Shared requests are automatically removed after their expiration time.
          </p>
        </div>
      </div>
    </main>
  );
}
